import { Routes } from '@angular/router';
import { ErrorComponent } from './error.component';

/**
 * Error routes
 * To be import in routes
 */
export const errorRoutes: Routes = [
  // Fallback: redirect any unknown route to apps landing
  { path: '**', redirectTo: '/apps' }
];
